
export function setLocations(state, payload) {
  state.all = payload;
}

export function setDeliveryMethods(state, payload) {
  state.deliveryMethods = payload;
}

export function setPaymentMethods(state, payload) {
  state.paymentMethods = payload;
}

export function setCurrentLocation(state, payload) {
  state.current = payload;
}
